import React, { useEffect } from 'react';
import styles from './ErrorPopup.module.css';
import { X, AlertTriangle } from 'lucide-react';

const ErrorPopup = ({ isOpen, onClose, title, message, autoClose = 5000 }) => {
  useEffect(() => {
    if (isOpen && autoClose) {
      const timer = setTimeout(() => {
        onClose();
      }, autoClose);
      
      return () => clearTimeout(timer);
    }
  }, [isOpen, autoClose, onClose]);

  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.popup} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <div className={styles.iconWrapper}>
            <AlertTriangle className={styles.icon} size={24} />
          </div>
          <button className={styles.closeButton} onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        
        <div className={styles.content}>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.message}>{message}</p>
        </div>
        
        <div className={styles.footer}>
          <button className={styles.confirmButton} onClick={onClose}>
            אישור
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorPopup;